import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin, Phone, ShieldCheck } from "lucide-react";
import { useStore } from "../../context/StoreContext";

export default function Footer() {
  const { settings, categories } = useStore();
  return (
    <footer className="bg-[#121214] text-[#FAF9F5] mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <div className="inline-flex bg-white rounded-xl px-4 py-2.5 mb-4">
              <img src="/assets/bigeldi-logo.png" alt="BIGELDİ" className="h-9 w-auto object-contain" />
            </div>
            <p className="font-serif-ed italic text-neutral-400 text-lg leading-snug">{settings?.slogan}</p>
            <div className="flex items-center gap-2 mt-6 text-xs text-neutral-400">
              <ShieldCheck size={16} className="text-emerald-500" /> 256-bit SSL ile güvenli alışveriş
            </div>
          </div>
          <div>
            <p className="font-mono-ed text-[11px] uppercase tracking-[0.25em] text-neutral-500 mb-4">Kategoriler</p>
            <ul className="space-y-2.5 text-sm text-neutral-300">
              {categories.slice(0, 5).map((c) => (
                <li key={c.category_id}><Link to={`/kategori/${c.slug}`} className="hover:text-amber-400 transition-colors">{c.name}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-mono-ed text-[11px] uppercase tracking-[0.25em] text-neutral-500 mb-4">Yardım</p>
            <ul className="space-y-2.5 text-sm text-neutral-300">
              <li><Link to="/siparis-takip" className="hover:text-amber-400 transition-colors">Sipariş Takibi</Link></li>
              <li><Link to="/hesabim" className="hover:text-amber-400 transition-colors">Hesabım</Link></li>
              <li><Link to="/sepet" className="hover:text-amber-400 transition-colors">Sepetim</Link></li>
            </ul>
          </div>
          <div>
            <p className="font-mono-ed text-[11px] uppercase tracking-[0.25em] text-neutral-500 mb-4">İletişim</p>
            <ul className="space-y-2.5 text-sm text-neutral-300">
              <li className="flex items-center gap-2"><Mail size={14} className="text-neutral-500" /> {settings?.contact_email}</li>
              <li className="flex items-center gap-2"><Phone size={14} className="text-neutral-500" /> {settings?.contact_phone}</li>
              {settings?.address && <li className="flex items-center gap-2"><MapPin size={14} className="text-neutral-500" /> {settings.address}</li>}
              {settings?.instagram && <li className="flex items-center gap-2"><Instagram size={14} className="text-neutral-500" /> {settings.instagram}</li>}
            </ul>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-neutral-500">
          <p>© 2026 BIGELDİ — bigeldi.com — Tüm hakları saklıdır.</p>
          <p className="font-mono-ed tracking-[0.2em] uppercase">Güvenli ödeme · Hızlı kargo · Kolay iade</p>
        </div>
      </div>
    </footer>
  );
}
